<template>
  <el-tabs v-model="activeName" @tab-click="tabClick" @tab-remove="removeTab">
    <el-tab-pane label="待确认" name="waitConfirm">
      <!-- 查询条件 -->
      <SampleSearchForm
        :listForm="searchList"
        @handlerSearch="item => onSearch(item, 'waitConfirm')"
      />
      <!-- 操作按钮 -->
      <div class="cml-button-group">
        <el-button
          type="primary"
          @click="confirmBtn"
          :disabled="waitConfirmSelectData.length === 0"
          v-hasPermission="'outside-warehouse-manage/outside-confirm-btn'"
          >确认</el-button
        >
      </div>
      <p class="confirm-tip">
        收到样品申请单，请先确认，实物寄出后再填写快递单号。
      </p>
      <!-- 表格 -->
      <CommonTable
        ref="waitConfirmCommonTable"
        :loading="tableLoading"
        :tableHead="tableHead"
        :tableData="waitConfirmTableData"
        :tableParam="waitConfirmTabelParam"
        @page-size-change="
          (pageNo, pageSize) => pageSizeChange(pageNo, pageSize, 'waitConfirm')
        "
        @select-change="selectChange"
      >
        <!-- 查看详情 -->
        <template #codeSlot="{ row }">
          <span class="detail-text-class" @click="toUpdate(row, 'detail')">{{
            row.code
          }}</span>
        </template>
      </CommonTable>
    </el-tab-pane>

    <el-tab-pane label="待寄出" name="waitSend">
      <!-- 查询条件 -->
      <SampleSearchForm
        :listForm="searchList"
        @handlerSearch="item => onSearch(item, 'waitSend')"
      />
      <!-- 操作按钮 -->
      <div class="cml-button-group">
        <el-button
          type="primary"
          @click="sendBtn"
          :disabled="waitSendSelectData.length === 0"
          v-hasPermission="'outside-warehouse-manage/outside-confirm-mail'"
          >寄出</el-button
        >
      </div>
      <!-- 表格 -->
      <CommonTable
        ref="waitSendCommonTable"
        :loading="tableLoading"
        :tableHead="[...tableHead, ...sendTableHead]"
        :tableData="waitSendTableData"
        :tableParam="waitSendTabelParam"
        @page-size-change="
          (pageNo, pageSize) => pageSizeChange(pageNo, pageSize, 'waitSend')
        "
        @select-change="selectChange"
      >
        <!-- 查看详情 -->
        <template #codeSlot="{ row }">
          <span class="detail-text-class" @click="toUpdate(row, 'detail')">{{ row.code }}</span>
        </template>
        <!-- 明细状态 -->
        <template #detailSlot="{ row }">
          <div>
            <el-button
              v-if="row.detailId"
              type="text"
              @click="ckeckDetail(row)"
              >查看明细</el-button
            >
          </div>
        </template>
      </CommonTable>
    </el-tab-pane>

    <el-tab-pane label="寻样确认" name="confirm" v-if="confirmTab" closable>
      <SampleConfrim
        :formList="waitConfirmSelectData"
        @success="successCallback('waitConfirm')"
        @cancel="cancelCallback('waitConfirm')"
      />
    </el-tab-pane>

    <el-tab-pane label="样品寄出" name="send" v-if="sendTab" closable>
      <SampleSend
        :formList="waitSendSelectData"
        @success="successCallback('waitSend')"
        @cancel="cancelCallback('waitSend')"
      />
    </el-tab-pane>
    <!-- 详情弹框 -->
    <el-dialog center top="5vh" :visible.sync="dialogVisible" width="1200px">
      <OutsideSample v-if="dialogVisible && status === 'detail'" :id="id" :detailId="detailId" />
      <div v-if="status === 'detail'" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </el-tabs>
</template>
<script>
import SampleSearchForm from '@/components/SampleSearchForm';
import CommonTable from '@/components/CommonTable';
import SampleConfrim from './SampleConfrim';
import SampleSend from './SampleSend';
import OutsideSample from '@/components/OutsideSample';
export default {
  name: 'outside-confirm',
  components: {
    SampleSearchForm,
    CommonTable,
    SampleConfrim,
    SampleSend,
    OutsideSample
  },
  data() {
    return {
      activeName: 'waitConfirm',
      searchList: {
        list: [
          {
            tag: 'el-input',
            label: '寻样单编号',
            prop: 'code',
            defaultValue: undefined,
            placeholder: '请输入完整寻样单编号',
          },
          {
            tag: 'el-input',
            label: '产品名称',
            prop: 'productName',
            defaultValue: undefined,
            placeholder: '请输入关键字',
          },
        ],
      },
      tableLoading: false,
      tableHead: [
        { label: '产品名称', prop: 'productName' },
        {
          label: '寻样单编号',
          prop: 'code',
          slotColumn: true,
          slotName: 'codeSlot',
        },
        { label: '申请时间', prop: 'createDate' },
        { label: '数量', prop: 'num', width: 80 },
        { label: '单位', prop: 'unit', width: 80 },
        { label: '采购备注', prop: 'forSupplierRemark' },
        { label: '要求到样时间', prop: 'askArrivalTime' },
      ],
      sendTableHead: [
        { label: '回复到样时间', prop: 'actualArrivalTime' },
        { label: '供应商备注', prop: 'supplierRemark' }
      ],
      waitConfirmTableData: {},
      waitSendTableData: {},
      waitConfirmTabelParam: {
        pageNo: 1,
        pageSize: 100,
        orderBy: '',
        data: {
          detailStatus: 'SAVE',
        },
      },
      waitSendTabelParam: {
        pageNo: 1,
        pageSize: 100,
        orderBy: '',
        data: {
          detailStatus: 'CONFIRM',
        },
      },
      waitConfirmSelectData: [],
      waitSendSelectData: [],
      confirmTab: false,
      sendTab: false,
      dialogVisible: false,
      status: '',
      id: '',
      detailId: ''
    };
  },
  mounted() {
    this.getTableList(this.activeName);
    this.$refs.waitConfirmCommonTable.changeHeight(10);
    this.$refs.waitSendCommonTable.changeHeight(10);
  },
  methods: {
    tabClick() {
      this.getTableList(this.activeName);
      if(!['waitConfirm', 'waitSend'].includes(this.activeName)) {
        return;
      }
    },
    // 查询按钮
    onSearch(item, status) {
      this[status + 'TabelParam'].data = {
        ...this[status + 'TabelParam'].data,
        ...item,
      };
      this.getTableList(this.activeName);
    },
    // 表格分页
    pageSizeChange(pageNo, pageSize, status) {
      this[status + 'TabelParam'].pageNo = pageNo;
      this[status + 'TabelParam'].pageSize = pageSize;
      this.getTableList(this.activeName);
    },
    selectChange(arr) {
      this[this.activeName + 'SelectData'] = arr;
    },
    // 列表查询
    getTableList() {
      if(!['waitConfirm', 'waitSend'].includes(this.activeName)) {
        return;
      }
      this.tableLoading = true;
      this.$http.outsideSampleManage
        .getConfirmOrderList(this[this.activeName + 'TabelParam'])
        .then(result => {
          this[this.activeName + 'TableData'] = result.data;
          this.$refs[this.activeName + 'CommonTable'].clearCheckboxRow();
          this[this.activeName + 'SelectData'] = [];
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 寻样确认
    confirmBtn() {
      this.activeName = 'confirm';
      this.confirmTab = true;
    },
    // 寄出
    sendBtn() {
      this.activeName = 'send';
      this.sendTab = true;
    },
    successCallback(val) {
      this.activeName = val;
      this.sendTab = false;
      this.confirmTab = false;
      this.getTableList();
    },
    cancelCallback(val) {
      this.activeName = val;
      this.confirmTab = false;
      this.sendTab = false;
      this.getTableList();
    },
    removeTab(val) {
      this[`${val}Tab`] = false;
      this.activeName = 'waitConfirm';
      this.getTableList(this.activeName);
    },
    // 修改，查看详情
    toUpdate(row, status) {
      this.status = status;
      this.id = row.id;
      this.detailId = '';
      this.dialogVisible = true;
      if(status === 'update') {
        this.$nextTick(() => {
          this.$refs.outsideApplySample.getDetail(row.id);
        })
      }
    },
    ckeckDetail(row) {
      this.status = 'detail';
      this.id = row.id;
      this.detailId = row.detailId;
      this.dialogVisible = true;
      if(status === 'update') {
        this.$nextTick(() => {
          this.$refs.outsideApplySample.getDetail(row.id);
        })
      }
    }
  },
};
</script>
<style lang="less" scoped>
.confirm-tip {
  position: absolute;
  right: 0;
  top: 1%;
  text-align: right;
  font-size: 12px;
  color: #AB0033;
  line-height: 14px;
  width: calc(100% - 850px);
  min-width: 160px;
}
</style>
